import http from "../redux/http";

export const getPostsAPI = async (
  size,
  page,
  category,
  search,
  blog,
  author,
  tag,
  keyword,
  userId,
  tagIds
) => {
  let params = {};
  if (size) params.size = size;
  if (page) params.page = page;
  if (category) params.category = category;
  if (search) params.search = search;
  if (blog) params.blogId = blog;
  if (author) params.author = author;
  if (tag) params.tag = tag;
  if (keyword) params.keyword = keyword;
  if (userId) params.userId = userId;
  if (tagIds) params.tagIds = tagIds;

  try {
    const { data } = await http.get("/blog_posts", {
      params,
    });

    return data.data;
  } catch (error) {
    return error;
  }
};

export const getPostsAPI_v2 = async ({
  size,
  page,
  category,
  search,
  blog,
  author,
  tag,
  keyword,
  userId,
  tagIds,
}) => {
  let params = {};
  if (size) params.size = size;
  if (page) params.page = page;
  if (category) params.category = category;
  if (search) params.search = search;
  if (blog) params.blogId = blog;
  if (author) params.author = author;
  if (tag) params.tag = tag;
  if (keyword) params.keyword = keyword;
  if (userId) params.userId = userId;
  if (tagIds) params.tagIds = tagIds;

  return await http.get("/blog_posts", {
    params,
  });
};

export const getPostsBySlugAPI = async (postSlug) =>
  await http.get(`/blog_posts/slug/${postSlug}`);

export const getBlogPostsSearchAPI = async ({ size, page, search, blog }) => {
  let params = {};
  if (size) params.size = size;
  if (page) params.page = page;
  if (search) params.search = search;
  if (blog) params.blogId = blog;

  return await http.get("/blog_posts", {
    params,
  });
};

export const getBlogPostsBookmarksAPI = async ({
  size,
  page,
  userId,
  blogPostId,
}) => {
  let params = {};
  if (size) params.size = size;
  if (page) params.page = page;
  if (blogPostId) params.blogPostId = blogPostId;
  if (userId) params.userId = userId;

  return await http.get("/blog_posts/bookmarks", {
    params,
  });
};
